import React from 'react';
import PropTypes from 'prop-types';

interface IconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
}

class Icon extends React.Component<IconProps> {
  static propTypes = {
    
  }

  render() {
    const { src, className, alt, ...rest } = this.props;

    return (
      <img
        src={src}
        className={className}
        alt={alt}
        {...rest}
      />
    );
  }
}

export default Icon;
